/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Severity levels. Each `name` in `SeverityName` correspond to the `value` in `SeverityValue`.
 *
 */
export var SeverityName;
(function (SeverityName) {
    SeverityName["LEVEL1"] = "level1";
    SeverityName["LEVEL2"] = "level2";
    SeverityName["LEVEL3"] = "level3";
    SeverityName["LEVEL4"] = "level4";
    SeverityName["LEVEL5"] = "level5";
})(SeverityName || (SeverityName = {}));
